import { PInlineNotification, PLinkPure } from "@porsche-design-system/components-react"
import { defineMessages, FormattedMessage } from "react-intl"
import { useConfig } from "src/hooks/useConfig/useConfig"

const messages = defineMessages({
	mediaEditText: {
		defaultMessage:
			"AI-generated or AI-manipulated content may require labeling under EU law.<br></br>Please refer to the <link>Porsche Brand Guide</link> for further guidance.<br></br>We strongly recommend not to artificially manipulate vehicle imagery. Please refer to the photography guidelines for further information.",
		id: "aiGeneratedContentNotification.mediaEditText",
	},
	text: {
		defaultMessage:
			"AI-generated or AI-manipulated content may require labeling under EU law.<br></br>Please refer to the <link>Porsche Brand Guide</link> for further guidance.",
		id: "aiGeneratedContentNotification.text",
	},
})

interface AiGeneratedContentNotificationProps {
	className?: string
	variant?: "default" | "mediaEdit"
}

export const AiGeneratedContentNotification = ({
	className,
	variant = "default",
}: AiGeneratedContentNotificationProps) => {
	const { isEuMarket } = useConfig()

	if (!isEuMarket) {
		return null
	}

	return (
		<PInlineNotification className={className} state="warning" dismissButton={false}>
			<FormattedMessage
				{...messages[variant === "mediaEdit" ? "mediaEditText" : "text"]}
				values={{
					br: () => <br />,
					link: (chunks) => (
						<PLinkPure
							href="https://brand.porsche.com/document/3846#/-/ai-labelling"
							icon="none"
							target="_blank"
							underline
						>
							{chunks}
						</PLinkPure>
					),
				}}
			/>
		</PInlineNotification>
	)
}
